// extracted by mini-css-extract-plugin
export default {"container":"DashboardItemsPerPage_container__iwcX4","selectContainer":"DashboardItemsPerPage_selectContainer__0kbXw","itemsPerPage":"DashboardItemsPerPage_itemsPerPage__Cs3BJ"};